<div class="lex-flex-table" [class.lex-flex-table--dense]="dense" [ngClass]="tableClass">
  <div class="lex-flex-table__header">
    @for (col of columns; track col) {
      <div class="lex-flex-table__column" [ngClass]="'lex-flex-table__column--' + col.id">
        {{ col.label }}
      </div>
    }
  </div>

  @if (rows?.length) {
    <div>
      <mat-action-list role="list">
        @for (item of rows; track item) {
          <button
            mat-list-item
            role="listitem"
            (click)="onRowClicked(item, $event)"
            class="lex-flex-table__row"
            [class.lex-flex-table__row--selected]="isItemSelected(item)"
            [ngClass]="rowClass(item)"
            [disableRipple]="disableRipple"
          >
            @for (cell of rowCells; track cell) {
              <div
                class="lex-flex-table__column"
                [ngClass]="'lex-flex-table__column--' + cell.appLexTableCell"
              >
                <ng-container
                  *ngTemplateOutlet="cell.template; context: { $implicit: item }"
                ></ng-container>
              </div>
            }
            @if (actions?.length) {
              <div
                class="lex-flex-table__actions"
                (mouseenter)="disableRipple = true"
                (mouseleave)="disableRipple = false"
              >
                @for (btn of actions; track btn) {
                  <xi-icon-button
                    color="CX"
                    [disabled]="btn.disabled && btn.disabled(item)"
                    [icon]="btn.icon"
                    buttonSize="normal"
                    [hasAnimation]="true"
                    (onClick)="onActionClicked($event, btn, item)"
                    [tooltip]="{ text: btn.tooltip && btn.tooltip(item), direction: 10 }"
                  >
                  </xi-icon-button>
                }
              </div>
            }
          </button>
        }
      </mat-action-list>
    </div>
  } @else {
    <div class="lex-flex-table__empty-view">
      {{ emptyViewLabel }}
    </div>
  }
</div>
